import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './style.scss';

// import module
import IcRcln from '@magaele/ic_rcln';

// plugin
import cx from 'classnames';

interface IModal {
    isOpen: boolean; // 從外部設定是否開啟
    children: JSX.Element;
    title: string;
    onClose?: (isOpen: boolean) => void;
    className?: string;
    contentHeight?: string; // 設定光箱預設高 ex: 100%
}

const Modal: React.FC<IModal> = (props) => {
    const { isOpen, children, title, onClose, className, contentHeight } = props;
    const moduleName = 'modal';
    const [open, setOpen] = useState<boolean>(isOpen);

    useEffect(() => {
        setOpen(isOpen);
        const body = document.querySelector('body');
        if (!body) return;
        if (isOpen) {
            body.style.overflow = 'hidden';
        } else {
            body.style.overflow = '';
        }
    }, [isOpen]);

    return ReactDOM.createPortal(
        <div className={cx(`${moduleName}_wrap`, className, { open: open })}>
            <div className={cx(`${moduleName}_content`)} style={{ height: contentHeight }}>
                <div className={cx(`${moduleName}_head`)}>
                    <div className={cx(`${moduleName}_title`)}>{title}</div>
                    <div className={cx('closeBtn')}>
                        <IcRcln
                            name="toolclose"
                            onClick={() => {
                                setOpen(false);
                                onClose && onClose(false);
                            }}
                            style={{ fontSize: '24px' }}
                        />
                    </div>
                </div>
                <div className={cx(`${moduleName}_body`)}>{children}</div>
            </div>
            <div
                className="overlay"
                onClick={() => {
                    setOpen(false);
                    onClose(false);
                }}
            />
        </div>,
        document.body
    );
};

export default Modal;

Modal.defaultProps = {
    contentHeight: '100%',
};
